import { useState } from "react";
import { useQuery } from "@apollo/client/react";
import { ListingMatchVersionsDocument } from "@/graphql/generated/operations";

export function useListingMatchVersions(listingId?: string) {
  const [watching, setWatching] = useState(false);
  const query = useQuery(ListingMatchVersionsDocument, {
    variables: { id: listingId ?? "" }, skip: !listingId,
    fetchPolicy: "cache-and-network", pollInterval: watching ? 5_000 : 0,
  });
  const running = !!listingId && !!query.data?.listing?.matches?.some(match => match.listingVersion?.state === "RUNNING");
  if (running !== watching) setWatching(running);
  return query;
}
